import constant from '../../constant'

// 公共参数
const initialState = {
  ch: 0,
  sDocId: null,
  shSid: null,
  sUserId: null,
  url: null,
  sGuid: null,
  actType: null
};

export function common (state = initialState, action) {
  switch (action.type) {
    case constant.COMMON.GET_PARAMS:
      return {
        ...state,
        ...action.common
      }
    default:
      return state
  }
}

export function pageState(state = {}, action) {
  switch (action.type) {
    case constant.COMMON.PAGE_STATE:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
